import { useQuery, gql } from "@apollo/client";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const GET_MANUFACTURERS = gql`
  query GET_MANUFACTURERS {
    findManyManufacturer(orderBy: { product_containers: { _count: desc } }) {
      id
      manufacturer_profiles {
        id
        name
        language
      }
    }
  }
`;

interface ManufacturerSelectProps {
  field: any;
}

const ManufacturerSelect: React.FC<ManufacturerSelectProps> = ({ field }) => {
  const { data, loading, error } = useQuery(GET_MANUFACTURERS);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading manufacturers</div>;

  const manufacturers = data?.findManyManufacturer || [];

  const selectedManufacturer = manufacturers.find(
    (manufacturer: any) => manufacturer.id === field.value
  );

  return (
    <Select
      onValueChange={(value) => field.onChange(Number(value))}
      value={String(field.value)}
    >
      <SelectTrigger>
        <SelectValue>
          {selectedManufacturer
            ? selectedManufacturer.manufacturer_profiles[0]?.name || "Unknown"
            : "Select a manufacturer"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {manufacturers.map((manufacturer: any) => (
          <SelectItem key={manufacturer.id} value={String(manufacturer.id)}>
            {manufacturer.manufacturer_profiles[0]?.name || "Unknown"}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ManufacturerSelect;
